var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMockExamSmartTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 53,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.667 22.372H7m15.167-8.667H7m39 17.333H7m39 8.667H7M39.5 5.038l-1.339 2.678c-.575 1.15-.862 1.725-1.247 2.224a6.504 6.504 0 0 1-1.18 1.18c-.498.384-1.073.671-2.224 1.247l-2.677 1.338 2.677 1.339c1.15.575 1.726.862 2.225 1.247.442.34.838.737 1.18 1.18.384.498.671 1.073 1.246 2.224l1.339 2.677 1.339-2.677c.575-1.15.862-1.726 1.247-2.224a6.504 6.504 0 0 1 1.18-1.18c.498-.385 1.073-.672 2.224-1.247l2.677-1.339-2.677-1.338c-1.15-.576-1.726-.863-2.225-1.248a6.504 6.504 0 0 1-1.18-1.18c-.384-.498-.671-1.073-1.246-2.223L39.5 5.038Z",
  stroke: "url(#mock-exam-smart-tool_svg__a)",
  strokeWidth: 4.34,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mock-exam-smart-tool_svg__a",
  x1: 7,
  y1: 22.372,
  x2: 48.167,
  y2: 22.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8BBDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BAD4FC"
})))));
export default SvgMockExamSmartTool;